import TemplateView from '../../../../../../js/TemplateView'
import {DateFormat, formatTime} from '../../../../../../js/date_format'
import messageResource from '../../../../../../js/messageResource'

export default class FeedLastSyncCell extends TemplateView {

    constructor({
        lastSyncDate,
    }) {
        super()

        this.params = {
            lastSyncDate
        }
    }

    templateHtml() {
        return `<div class='lastSyncCell'>
                    <div class='syncDate'/>
                </div>`
    }

    afterRender() {
        const convertedLastSyncDate = this.params.lastSyncDate
                                        ? window.convertFromSystemTimeZoneToUser(this.params.lastSyncDate)
                                        : null
        this.find('.syncDate').text(this._getTextForLastSync(convertedLastSyncDate))
    }

    _getTextForLastSync = timestamp => {
        if (!timestamp) {
            return messageResource.getMessage('date.format.none')
        }

        const currentTime = window.currentUserTime()
        if (currentTime.isSameDate(timestamp)) {
            return messageResource.getMessage('date.format.today', [formatTime(timestamp)])
        } else {
            return this._getTextForOffsetLastSync(timestamp, currentTime)
        }
    }

    _getTextForOffsetLastSync = (lastSync, currentTime) => {
        const offset = currentTime.offsetInDaysFrom(lastSync)
        if (offset === 1) {
            return messageResource.getMessage('date.format.yesterday')
        } else if (offset <= 7) {
            return messageResource.getMessage('date.format.past', [offset])
        } else {
            const dateFormat = currentTime.getYear() === lastSync.getYear()
                               ? new DateFormat('MMM dd')
                               : new DateFormat('MMM dd, yyyy')
            return dateFormat.formatDate(lastSync)
        }
    }
}



// WEBPACK FOOTER //
// ./web/actiplans/js/icalendar/components/table/cells/FeedLastSyncCell.js